import { EntityModel } from '@/interfaces'
import { ALL_FAQS_QUERY, CREATE_FAQ_MUTATION, DELETE_FAQ_MUTATION, FORCE_DELETE_FAQ_MUTATION, SINGLE_FAQ_QUERY, UPDATE_FAQ_MUTATION } from './graphql'

const travelFaqModel: EntityModel = {
  name: 'faq',
  namePlural: 'faqs',
  uniqueName: 'travelFaq',
  uniqueNamePlural: 'travelFaqs',
  path: 'travel/faq',
  baseUrl: '/travel/faqs',
  translationPrefix: 'entities:travelFaq.',
  getDisplayName: (values: any) => {
    return values.question
  },
  gql: {
    getAll: ALL_FAQS_QUERY,
    getSingle: SINGLE_FAQ_QUERY,
    create: CREATE_FAQ_MUTATION,
    update: UPDATE_FAQ_MUTATION,
    delete: DELETE_FAQ_MUTATION,
    forceDelete: FORCE_DELETE_FAQ_MUTATION,
  },
  attributes: {
    question: {
      name: 'question',
      label: 'entities:travelFaq.attributes.question.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    answer: {
      name: 'answer',
      label: 'entities:travelFaq.attributes.answer.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'wysiwyg',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default travelFaqModel
